import { render, staticRenderFns } from "./tableSearchStudent.vue?vue&type=template&id=51083768&"
import script from "./tableSearchStudent.js?vue&type=script&lang=js&"
export * from "./tableSearchStudent.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports